import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './css/Certificado.css';
import logo from "../img/logo.png";

const Certificado = () => {
  const { certificadoId } = useParams();
  const [certificado, setCertificado] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCertificado = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/certificado/${certificadoId}`,{
          credentials: 'include'
        });
        const data = await response.json();

        if (response.ok) {
          setCertificado(data);
        } else {
          console.error('Erro ao buscar certificado:', data);
        }
      } catch (error) {
        console.error('Erro de rede:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificado();
  }, [certificadoId]);

  const formatarData = (data) => {
    const partes = data.split('-');
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (!certificado) {
    return <div>Certificado não encontrado.</div>;
  }

  return (
    <div className="certificado">
      <img src={logo} alt="Logo" className="logo" />
      <h1>Certificado de {certificado.nome}</h1>

      <p className="curso"><strong>Curso:</strong> <span className="curso-destaque">{certificado.curso}</span></p>
      <p><strong>Professor:</strong> {certificado.professor}</p>
      <p><strong>Data de Início:</strong> {formatarData(certificado.data_inicio)}</p>
      <p><strong>Data de Término:</strong> {formatarData(certificado.data_fim)}</p>
      <p><strong>Carga Horária:</strong> {certificado.carga_horaria} horas</p>
      <p><strong>CPF:</strong> {certificado.cpf}</p>
      <p><strong>Email:</strong> {certificado.email}</p>
      <p><strong>Telefone:</strong> {certificado.telefone}</p>

      <h2>Disciplinas</h2>
      <div className="disciplinas">
        <table>
          <thead>
            <tr>
              <th>Disciplina</th>
              <th>Carga Horária</th>
            </tr>
          </thead>
          <tbody>
            {certificado.disciplinas.map((disciplina, index) => (
              <tr key={index}>
                <td>{disciplina.disciplina}</td>
                <td>{disciplina.carga_horaria} horas</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {certificado.arquivo_certificado ? (
        <div>
          <h2>Baixar Certificado</h2>
          <a
            href={`${process.env.REACT_APP_API_URL}/certificados/${certificadoId}/download`}
            target="_blank"
            rel="noopener noreferrer"
            className="botao-download"
          >
            📄 Baixar Certificado em PDF
          </a>
        </div>
      ) : (
        <p>O certificado ainda não está disponível para download.</p>
      )}
    </div>
  );
};

export default Certificado;
